// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Carousel_wrapper__wmIq6"};